import React, { useState, useEffect } from "react";
import Button from "../../button/Button";
import "./DeleteForm.css";
import axios from "axios";
import { apiUrl } from "../../../constants";
import FunctionalButton from "../../button/FunctionalButton";

const DeleteForm = ({
  route,
  title,
  idItemToBeUpdated,
  itemToBeDeleted,
  toggleShowFullList,
  toggleDisplayContainer,
  toggleReloadAll,
}) => {
  const [dataReady, toggleDataReady] = useState(false);
  const [success, toggleSuccess] = useState(false);
  const [errorMessage, toggleErrorMessage] = useState(false);
  const [loading, toggleLoading] = useState(false);
  const [displayForm, toggleDisplayForm] = useState(true);
  const [databaseMessage, setDatabaseMessage] = useState("");
  const [publisherInUseIn, setPublisherInUseIn] = useState([]);

  function deleteItem(e) {
    e.preventDefault();
    toggleDataReady(true);
  }

  useEffect(() => {
    async function sendData() {
      toggleErrorMessage(false);
      toggleLoading(true);
      toggleSuccess(false);
      const jwtToken = localStorage.getItem("token");
      try {
        const result = await axios.delete(
          `${apiUrl}/formsettings/${route}/${idItemToBeUpdated}`,
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        );

        if (Array.isArray(result.data)) {
          function sortResult(resultToBeSorted) {
            const sortedResult = resultToBeSorted.sort((a, b) => {
              if (a.specsheet.templateName < b.specsheet.templateName) {
                return -1;
              }
              if (a.specsheet.templateName > b.specsheet.templateName) {
                return 1;
              }
              return 0;
            });
            return sortedResult;
          }
          setPublisherInUseIn(sortResult(result.data));
        } else {
          setDatabaseMessage(result.data);
          toggleSuccess(true);
        }

        toggleDisplayForm(false);
      } catch (e) {
        console.error(e);
        toggleDisplayForm(false);
        toggleErrorMessage(true);
        if (e.response !== undefined) {
          setDatabaseMessage(e.response.data.message);
        } else {
          setDatabaseMessage("Something went wrong. Please try again later.");
        }
      }
      toggleLoading(false);
    }

    if (dataReady) {
      sendData();
    }
  }, [dataReady]);

  function returnToOverview() {
    toggleShowFullList(true);
    toggleDisplayForm(false);
    toggleDisplayContainer(false);
    toggleReloadAll(true);
  }

  return (
    <div className="delete-form-container">
      {displayForm === true && (
        <form onSubmit={deleteItem} className="settings-delete-form">
          <h4>Delete {title}</h4>

          <p>{`Are you sure you would like to delete: ${itemToBeDeleted}?`}</p>

          <div className="delete-settings-button-section-wrapper">
            <div className="loading-delete-wrapper">
              {loading && <p className="loading-delete-form">Loading...</p>}
            </div>
            <section className="button-wrapper-delete-settings">
              <FunctionalButton type="button" handleClick={returnToOverview}>
                No
              </FunctionalButton>
            </section>
            <section className="button-wrapper-delete-settings-yes">
              <Button type="submit">Yes</Button>
            </section>
          </div>
        </form>
      )}

      {errorMessage && (
        <section className="error-section">
          <p>{databaseMessage}</p>
        </section>
      )}



      {success && (
        <section>
          <p className="success-message">{databaseMessage}</p>

          <FunctionalButton type="button" handleClick={returnToOverview}>
            {`Return to ${title} list`}
          </FunctionalButton>
        </section>
      )}
      {publisherInUseIn.length > 0 && (
        <div>
          <p className="instruction-message">
            The publisher you would like to delete is in use
          </p>
          <p className="instruction-subtitle-message">
            Please change the following specsheet(s) to a different publisher.
          </p>
          <p className="template-active">Green is an "active" specsheet</p>
          <p className="template-notActive">Red is a "not active" specsheet</p>
        </div>
      )}
      {publisherInUseIn?.map((item) => {
        const { _id, templateName, active, country } = item.specsheet;

        return (
          <div key={_id} className="publisher-in-use-item">
            <p className={`template-` + `${active}`}>{templateName}</p>
            <p>Country: {country}</p>
          </div>
        );
      })}
    </div>
  );
};

export default DeleteForm;
